/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingprofilesubtitle2Inputs */

const en_onboardingprofilesubtitle2 = /** @type {(inputs: Onboardingprofilesubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This decides how your dashboard is set up.`)
};

const de_onboardingprofilesubtitle2 = /** @type {(inputs: Onboardingprofilesubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davon hängt ab, wie dein Dashboard aufgebaut ist.`)
};

/**
* | output |
* | --- |
* | "This decides how your dashboard is set up." |
*
* @param {Onboardingprofilesubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingprofilesubtitle2 = /** @type {((inputs?: Onboardingprofilesubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingprofilesubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingprofilesubtitle2(inputs)
	return de_onboardingprofilesubtitle2(inputs)
});
export { onboardingprofilesubtitle2 as "onboardingProfileSubtitle" }